import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

export class HttpService {
  private cache: { [url: string]: Observable<any> } = {};

  protected cacheFirst<T>(url: string, request: Observable<T>): Observable<T> {
    if (!this.cache[url]) {
      this.cache[url] = request.pipe(shareReplay(1));
    }
    return this.cache[url];
  }
}
